// login.service.ts
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { PoNotificationService } from "@po-ui/ng-components";
import { Observable, throwError } from "rxjs";
import { catchError, retry } from "rxjs/operators";
import { environment } from "../../environments/environment";

import { Usuario } from "./usuario";
import { AuthService } from "../guards/auth.service";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  public token: string;
  private url = `${environment.API}sessions`;
  private urlVersao = `${environment.API}versao`;
  private urlEmail = `${environment.API}emailrecovery`;
  private usuarioAutenticado: boolean = false;
  private version = `${environment.versao}`;

  constructor(
    private router: Router,
    public poNotification: PoNotificationService,
    private http: HttpClient,
    private authService: AuthService
  ) {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.token = currentUser && currentUser.token;
  }

  enviaEmail(email): Observable<any> {
    return this.http.post(this.urlEmail, { email });
  }

  getVersao(): Observable<any> {
    return this.http.get(this.urlVersao);
  }

  fazerLogin(usuario: Usuario): Observable<any> {
    return this.http
      .post(this.url, {
        login: usuario.user,
        password: usuario.senha,
        versao: this.version,
      })
      .pipe(
        retry(1),
        catchError(this.handleError)
      );
  }

  ClickLogin(usuario: Usuario): Boolean {
    let login = false;

    this.fazerLogin(usuario).subscribe(
      (response) => {
        if (response.token) {
          usuario.nome = response.user.nome;
          sessionStorage.setItem("token", response.token);
          sessionStorage.setItem("user", usuario.user.toString());
          sessionStorage.setItem("userName", response.user.nome);
          sessionStorage.setItem("userVendedor", response.user.codven);
          sessionStorage.setItem("codeuser", response.user.codigo);
          sessionStorage.setItem("tipoUser", response.user.tipo);

          this.usuarioAutenticado = true;

          // Atualiza o estado global via AuthService
          this.authService.setMostrarMenu(true);
          // Define o valor do tipo do usuário conforme a resposta (exemplo: 'U' significa true)
          if (response.user.tipo === "U") {
            this.authService.setTipoUser(true);
          } else {
            this.authService.setTipoUser(false);
          }

          this.poNotification.setDefaultDuration(2500);
          this.poNotification.success(`${usuario.nome}, bem-vindo!`);
          login = true;

          // Redireciona com base no tipo do usuário
          if (response.user.tipo === "A") {
            this.router.navigate(["/adm_orcamento"]);
          } else {
            this.router.navigate(["/"]);
          }
        } else {
          this.usuarioAutenticado = false;
          this.poNotification.setDefaultDuration(5000);
          this.poNotification.error("Verifique seu usuário!");
          this.authService.setMostrarMenu(false);
        }
      },
      (err) => {
        this.usuarioAutenticado = false;
        this.poNotification.setDefaultDuration(10000);
        this.poNotification.error(err);
        this.authService.setMostrarMenu(false);
      }
    );

    return login;
  }

  fazerLogout() {
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("userName");
    sessionStorage.removeItem("userVendedor");
    sessionStorage.removeItem("tipoUser");
    sessionStorage.removeItem("codeuser");
    sessionStorage.removeItem("Segmento");
    sessionStorage.removeItem("cgc");
    sessionStorage.removeItem("tabprc");
    sessionStorage.removeItem("tpop");
    sessionStorage.removeItem("empresa");
    sessionStorage.removeItem("cpg");

    this.usuarioAutenticado = false;

    // Atualizando os states para refletir que o usuário saiu
    this.authService.setMostrarMenu(false);
    this.authService.setTipoUser(false);

    this.token = null;
    this.router.navigate(["/login"]);
  }

  usuarioEstaAutenticado(): boolean {
    return this.usuarioAutenticado;
  }

  
  handleError(error: HttpErrorResponse) {
    let errorMessage = "";
    if (error.error instanceof ErrorEvent) {
      // Erro ocorrido no lado do cliente
      errorMessage = error.error.message;
    } else {
      // Erro ocorrido no lado do servidor
      errorMessage = error.error.error;
    }
    return throwError(errorMessage);
  }
}
